import api from '../config/api';

const API_ENDPOINTS = {
  DEPARTMENTS: '/departments'
};

export const departmentService = {
  // Get all departments (company-specific)
  async getAllDepartments() {
    try {
      console.log('🔍 Fetching departments from:', API_ENDPOINTS.DEPARTMENTS);
      const response = await api.get(API_ENDPOINTS.DEPARTMENTS);
      console.log('📊 Departments API response:', response);
      
      // Handle different response structures
      let departmentsData;
      if (response.data.data && Array.isArray(response.data.data)) {
        departmentsData = response.data.data;
      } else if (Array.isArray(response.data)) {
        departmentsData = response.data;
      } else {
        departmentsData = [];
      }
      
      return { 
        success: true, 
        data: departmentsData 
      };
    } catch (error) {
      console.error('Error fetching departments:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch departments' 
      };
    }
  },

  // Get departments by company
  async getDepartmentsByCompany(companyId) {
    try {
      const response = await api.get(`${API_ENDPOINTS.DEPARTMENTS}/company/${companyId}`);
      return { 
        success: true, 
        data: response.data.data || response.data || [] 
      };
    } catch (error) {
      console.error('Error fetching company departments:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch company departments' 
      };
    }
  },

  // Get department by ID
  async getDepartmentById(departmentId) {
    try {
      const response = await api.get(`${API_ENDPOINTS.DEPARTMENTS}/${departmentId}`);
      return { 
        success: true, 
        data: response.data.data || response.data 
      };
    } catch (error) {
      console.error('Error fetching department:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch department' 
      };
    }
  },

  // Create department
  async createDepartment(departmentData) {
    try {
      console.log('🆕 Creating department:', departmentData);
      const response = await api.post(API_ENDPOINTS.DEPARTMENTS, departmentData);
      console.log('✅ Department created:', response.data);
      
      return { 
        success: true, 
        data: response.data.data || response.data 
      };
    } catch (error) {
      console.error('Error creating department:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to create department' 
      };
    }
  },

  // Update department
  async updateDepartment(departmentId, departmentData) {
    try {
      console.log('📝 Updating department:', departmentId, departmentData);
      const response = await api.put(`${API_ENDPOINTS.DEPARTMENTS}/${departmentId}`, departmentData);
      console.log('✅ Department updated:', response.data);
      
      return { 
        success: true, 
        data: response.data.data || response.data 
      };
    } catch (error) {
      console.error('Error updating department:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to update department' 
      };
    }
  },

  // Delete department
  async deleteDepartment(departmentId) {
    try {
      console.log('🗑️ Deleting department:', departmentId);
      const response = await api.delete(`${API_ENDPOINTS.DEPARTMENTS}/${departmentId}`);
      console.log('✅ Department deleted:', response.data);
      
      return { 
        success: true, 
        message: response.data.message || 'Department deleted successfully' 
      };
    } catch (error) {
      console.error('Error deleting department:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to delete department' 
      };
    }
  }
};

export default departmentService;
